import React from "react";
import GreenDotIcon from "../../assets/img/GreenDotIcon.svg";
import ArrowUpWhite from "../../assets/icons/ArrowUpWhite.svg";
import { BaseButton } from "../base";
import moment from "moment";
import BaseStatusLabel from "../base/BaseStatusLabel";
import { Order } from "../../store/slices/order/types";

const OldOrderItem = ({
  oldOrder,
  setShowResult,
  setSelectedOrder,
}: {
  oldOrder: Order;
  setShowResult: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedOrder: React.Dispatch<React.SetStateAction<Order | null>>;
}) => {
  const viewResult = () => {
    setSelectedOrder(oldOrder);
    setShowResult(true);
  };

  return (
    <>
      <div
        className="hidden hover:bg-slate-50 hover:font-medium lg:flex justify-between items-center bg-white lg:px-4 xl:px-8 py-4 rounded-[0.5rem] mb-2"
        onClick={viewResult}
      >
        <div className="flex items-center">
          <div>
            <div className="flex mb-2 items-center">
              <div className="">
                <img
                  src={GreenDotIcon}
                  alt="green dot icon"
                  className="w-full h-full"
                />
              </div>
              <div className="mx-2 xl:mx-4 flex">
                <h3 className="text-[0.875rem] text-[#0C4654] font-[500]">
                  {oldOrder?.firstName} {oldOrder?.lastName}
                </h3>

                <h3 className="text-[0.875rem] text-[#0C4654] px-1 font-[500]">{`(${moment(
                  oldOrder?.orderedDateTime
                ).format("Do MMM, YYYY")})`}</h3>
              </div>
            </div>
            <div className="flex max-w-full">
              {oldOrder?.products?.length > 0 ? (
                oldOrder?.products?.slice(0, 3).map((product) => (
                  <div className="flex items-center mr-2" key={product?._id}>
                    <div>
                      <img
                        src={GreenDotIcon}
                        alt="green dot icon"
                        className="w-1 h-1 mx-1"
                      />
                    </div>
                    <p className="text-[0.625rem] text-[#0C4654]">
                      {product.name}
                    </p>
                  </div>
                ))
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="mx-2 xl:mx-4">
            <BaseStatusLabel status={oldOrder?.orderStatus} />
          </div>
        </div>
        <BaseButton
          text="View Result"
          variant="primary"
          hasRightIcon={true}
          styles="!bg-[#F2F6FA] !text-[#525256] px-4 !h-10 font-[500] xl:w-full xl:!px-8"
          click={viewResult}
        >
          <img
            src={ArrowUpWhite}
            alt="green dot icon"
            className="w-[15px] rotate-90 xl:w-[20px] ml-2"
          />
        </BaseButton>
        {/* {(order?.status === 'ResultSentComplete' || order?.status === 'ResultSentIncomplete') && (
                    <div className="flex items-center justify-center">
                    <div>
                    <BaseButton
                                text="View Result"
                                variant="primary"
                                styles="!bg-[#3A966C] !text-[0.875rem] px-4 !h-10 font-[500] xl:w-full xl:!px-8"
                                click={viewResultModal}
                                />
                                </div>
                                <div className="mx-5">
                                    <BaseButton
                                        click={handleDownload}
                                        text="Download"
                                        hasRightIcon={true}
                                        variant="neutral"
                                        styles="!bg-[#F2F6FA] text-[#525256] !text-[0.875rem]  border-0 !h-10  font-[500] px-4 xl:!px-8 xl:w-full">
                                        <Image src={ArrowUp} alt="green dot icon" className="w-[15px] xl:w-[20px] ml-2" />
                                    </BaseButton>
                                </div>
                                </div>
                )} */}
      </div>

      {/* mobile view */}
      <div
        className="flex flex-col bg-[#ffffff] rounded-[1rem] my-4 px-4 py-6  lg:hidden"
        onClick={viewResult}
      >
        <div className="flex items-center ">
          <div>
            <div className=" mb-2 items-center text-[0.5rem]">
              <BaseStatusLabel status={oldOrder?.orderStatus} />
            </div>
            <div className="my-4 xl:mx-4">
              <h3 className="text-[0.825rem] text-[#0C4654] font-[400]">
                {oldOrder.uniqueId}
              </h3>

              <h3 className="text-[0.75rem] text-[#0C4654] font-[500]">{`(${moment(
                oldOrder?.orderedDateTime
              ).format("Do MMM, YYYY")})`}</h3>
            </div>
          </div>
        </div>

        <BaseButton
          text="View Result"
          variant="primary"
          hasRightIcon={true}
          styles="!bg-[#3A966C] !text-[0.825rem] px-4 !h-10 font-[400] xl:w-full xl:!px-8"
          click={viewResult}
        >
          <img
            src={ArrowUpWhite}
            alt="arrow"
            className="w-[14px] rotate-90 ml-2"
          />
        </BaseButton>
      </div>
    </>
  );
};

export default OldOrderItem;
